import Version from './Version'

export default Version;